// extracted by mini-css-extract-plugin
export default {"wrapper":"size-wrapper_wrapper__U2yRK"};